import { takeLatest } from 'redux-saga/effects';
import { createAsyncAction, getType } from 'typesafe-actions';

import { SAVE_GROUP_SUCCESS } from 'containers/DialogGroup/constants';

import sagaRelayInvalidateData from './sagaRelayInvalidateData';

const DELETE_GROUP_USER_SUCCESS = 'lumahealth/sagaWatchersGroup/DELETE_GROUP_USER_SUCCESS';

export const actionCreateGroup = createAsyncAction(
  'actionCreateGroup/REQUEST',
  'actionCreateGroup/SUCCESS',
  'actionCreateGroup/FAILURE',
)<any, any, any>();

export const actionEditGroup = createAsyncAction(
  'actionEditGroup/REQUEST',
  'actionEditGroup/SUCCESS',
  'actionEditGroup/FAILURE',
)<any, any, any>();

function* sagaInvalidateStore() {
  yield sagaRelayInvalidateData('Group');
}

export default function* sagaWatchersGroup() {
  // Invalidate data on Relay store and refetch queries
  yield takeLatest(SAVE_GROUP_SUCCESS, sagaInvalidateStore);
  yield takeLatest(DELETE_GROUP_USER_SUCCESS, sagaInvalidateStore);
  yield takeLatest(getType(actionCreateGroup.success), sagaInvalidateStore);
  yield takeLatest(getType(actionEditGroup.success), sagaInvalidateStore);
}
